import { Button } from '@wartek-id/button'

export const ApplyFilterButton = ({ onClick }) => {
  return (
    <Button color="black" onClick={onClick} className="max-w-[95px]">
      Terapkan
    </Button>
  )
}
